import React from 'react'
import styles from './clubCard.module.css'
import { Link } from 'react-router-dom'

interface TeamShort {
	team_id: number;
	team_club_id: number;
	team_club_short_name: string;
	team_club_logo: string;
	team_club_city: string;
	team_club_country: string;
}
interface ClubCardProps {
	club: TeamShort
}

const ClubCard: React.FC<ClubCardProps> = ({ club }) => {
	return (
		<li className={styles.club_card}>
			<Link to={`/teams/${club.team_id}/squad`}>
				<img src={club.team_club_logo} alt={`${club.team_club_short_name} logo`} />
			</Link>
			<div className={styles.club_info}>
				<h3>{club.team_club_short_name}</h3>
				<p>{club.team_club_city}</p>
			</div>
		</li>
	)
}

export default ClubCard
